import React from 'react'
import cx from 'classnames'
import config from 'app-config'
import { compose } from 'helpers'
import { connect } from 'redaction'

import injectGlobals from 'local_modules/injectGlobals'

import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'

import s from './WeatherIcon.scss'


const WeatherIcon = ({ host, icons, weather: { temp_max } = {}, onClick }) => (
  <div className={s.icon} onClick={onClick}>
    <Box pr="8">
      {
        Boolean(icons && icons.length) ? (
          icons.map((icon, index) => (
            <img
              key={index}
              className={cx({
                [s.hover]: /hover|thermometer30red\.png/.test(icon),
                [s.default]: !/hover|thermometer30red\.png/.test(icon),
              })}
              src={`${host}/img/${icon}`}
            />
          ))
        ) : (
          <span>   </span>
        )
      }
    </Box>
    <Text
      className={s.text}
      message={`${temp_max}°`}
      tag="span"
      size="14-17"
      weight="semibold"
      color="white"
    />
  </div>
)


export default compose(
  injectGlobals(({ globals }) => ({
    host: config.api === 'test' ? 'https://smartsarov.ru' : `https://${globals.host || 'smartsarov.ru'}`,
  })),
  connect({
    icons: 'ui.icons',
    weather: 'ui.weather',
  }),
)(WeatherIcon)
